export default __webpack_public_path__ + "static/realWorldImg1-426c440a37c80ab4a5c64447544d7b11.png";